export const RACE = [
  { text: 'Malay', value: 'Malay' },
  { text: 'Chinese', value: 'Chinese' },
  { text: 'Indian', value: 'Indian' },
  { text: 'Kadazan Dusun', value: 'Kadazan Dusun' },
  { text: 'Bajau', value: 'Bajau' },
  { text: 'Murut', value: 'Murut' },
  { text: 'Iban', value: 'Iban' },
  { text: 'Bidayuh', value: 'Bidayuh' },
  { text: 'Melanau', value: 'Melanau' },
  { text: 'Orang Ulu', value: 'Orang Ulu' },
  { text: 'Others (Please Fill In)', value: 'Others' },
  { text: 'Not Applicable', value: 'Not Applicable' },
];
export default RACE;



// WEBPACK FOOTER //
// ./src/constants/race.js